export enum ColWidth {
  mini = "90",
  sm = "110",
  md = "130",
  lg = "150",
  xl = "200",
  xxl = "250",
}

export enum Status {
  申請前 = "11",
  申請中 = "12",
  承認 = "21",
  保留 = "22",
  期限切 = "91",
}

export enum Shinchoku {
  保存 = "0",
  仮申請 = "1",
  仮承認 = "2",
  仮保留 = "3",
  取消 = "9",
}

export enum DatePattern {
  DatePattern = "YYYY-MM-DD",
  SimpleDatePattern = "YYYYMMDD",
  DateTimePattern = "YYYY-MM-DD HH:mm:ss",
}
